<!--
  * @Author: changyunxia
  * @Date:2020年10月19日 10:15:21
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月19日 10:15:21
  * @Description: 我的会议列表
  * @FilePath:@/components/myMeeting/MyMeetingList.vue
-->
<template>
  <div>
    <!-- 空提示 -->
    <!-- v-else  -->
    <div class="mg">
      <div v-if="!cycleMeet">
        <van-empty v-if="myData.length===0" description="暂无会议" />
        <MeetingListChid v-for="(item , index) in list" v-else :key="index" :my-data="item" :cycle-meet="false" />
      </div>
      <!-- 周期会议 -->
      <div v-else>
        <van-empty v-if="groupData.length===0" description="暂无会议" />
        <MeetingListChid v-for="(item , index) in groupData" v-else :key="index" :my-data="item" :cycle-meet="true" />
      </div>

      <div style="height:60px; width:100%" />
    </div>
  </div>
</template>

<script>
import MeetingListChid from '@/components/myMeeting/meetingListChid'

export default {
  name: 'MyMeetingList',
  components: { MeetingListChid },
  props: {
    myData: {
      type: Array,
      default: null
    },
    group: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      emptyShow: false,
      list: this.myData,
      cycleMeet: false,
      groupData: this.group
    }
  },
  computed: {},
  watch: {
    myData: {
      handler(nVal) {
        this.list = nVal
      },
      immediate: true,
      deep: true
    },
    group: {
      handler(nVal) {
        this.groupData = nVal
      },
      immediate: true,
      deep: true
    },
    cycleMeet(nVal) {}

  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.mg{
    margin-top: 10px;
    background: #fafbfc;
}
</style>
